import { ReducerState } from "../../../state/reducers/types"
import { addOrUpdate, remove } from "../../../state/reducers/utils"
import { ActionType, SalesAction } from './actionTypes'
import { Budget, Customer, CustomerType, HoardOrder, SaleOrder } from "./types"

export type SalesState = {
    sales: SaleOrder[],
    budgets: Budget[],
    hoards: HoardOrder[],
    customers: Customer[],
    customerTypes: CustomerType[]
}

const initialState: SalesState = {
    sales: [],
    budgets: [],
    hoards: [],
    customers: [],
    customerTypes: []
}

const reducer = (state = initialState, action: SalesAction) => {
    switch(action.type) {
        case ActionType.SET_SALES:
            return {
                ...state,
                sales: action.payload
            }
        case ActionType.UPDATE_SALES:
            return { 
                ...state,
                sales: addOrUpdate(state, action, 'sales' as keyof ReducerState)
            }
        case ActionType.REMOVE_SALES:
            return { 
                ...state,
                sales: remove(state, action, 'sales' as keyof ReducerState)
            }
        case ActionType.UPDATE_BUDGETS:
            return { 
                ...state,
                budgets: addOrUpdate(state, action, 'budgets' as keyof ReducerState)
            }
        case ActionType.REMOVE_BUDGETS:
            return { 
                ...state,
                budgets: remove(state, action, 'budgets' as keyof ReducerState)
            }
        case ActionType.SET_HOARDS:
            return {
                ...state,
                hoards: action.payload
            }
        case ActionType.UPDATE_HOARDS:
            return { 
                ...state,
                hoards: addOrUpdate(state, action, 'hoards' as keyof ReducerState)
            }
        case ActionType.REMOVE_HOARDS:
            return { 
                ...state,
                hoards: remove(state, action, 'hoards' as keyof ReducerState)
            }
        case ActionType.SET_CUSTOMERS:
            return {
                ...state,
                customers: action.payload
            }
        case ActionType.UPDATE_CUSTOMERS:
            return { 
                ...state,
                customers: addOrUpdate(state, action, 'customers' as keyof ReducerState)
            }
        case ActionType.REMOVE_CUSTOMERS:
            return { 
                ...state,
                customers: remove(state, action, 'customers' as keyof ReducerState)
            }
        case ActionType.SET_CUSTOMER_TYPES:
            return {
                ...state,
                customerTypes: action.payload
            }
        case ActionType.UPDATE_CUSTOMER_TYPES:
            return {
                ...state,
                customerTypes: addOrUpdate(state, action, 'customerTypes' as keyof ReducerState)
            }
        case ActionType.REMOVE_CUSTOMER_TYPES:
            return {
                ...state,
                customerTypes: remove(state, action, 'customerTypes' as keyof ReducerState)
            }
        default:
            return state
    }
}

export default reducer
